<template>
  <section id="section-other-indice" class="section-trending">
    <h2>Other Indices</h2>
    <div class="fade" id="fade-indices"></div>
    <swiper v-if="getIndiceRanking.length" :options="swiperOption" class="trending-list">
      <swiper-slide class="item" v-for="indice in sortData" :key="indice.id">
        <a
          @click="onSelected(indice)"
          data-action="open_index"
          data-listname="other_indices"
          data-assettype="indices"
          :data-stockname="indice.name"
          :data-assetname="indice.name"
          style="text-decoration:none"
        >
          <div class="trending-data">
            <h4>{{indice.name}}</h4>
            <time>
              <i class="fal fa-clock"></i>
              {{indice.data_date | dateFilter}}
            </time>
            <div
              class="percent"
              v-bind:class="{ plus: indice.percent > 0, minus: indice.percent < 0 }"
            >{{indice.percent | percent}}</div>
            <div class="price">{{indice.price | currency}} ฿</div>
            <!-- <label class="order-trending" for>{{index+1}}</label> -->
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div id="search-loading" v-else>
      <i class="loading fas fa-spinner-third fa-spin"></i>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import _shuffle from "lodash/shuffle";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import GlobalMarketFunc from "../../mixins/global-market-functions";
import { mapGetters } from "vuex";

export default {
  mixins: [GlobalMarketFunc],
  components: {
    swiper,
    swiperSlide
  },
  props: {
    exclude: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        loop: false,
        // slidesPerView: 1,
        lazy: true,
        // spaceBetween: 5,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange() {}
          //   tap() {}
        }
      }
    };
  },
  filters: {
    dateFilter(date) {
      return moment(date).format("DD/MM/YY");
    },
    currency: function(val) {
      let toNumber = parseFloat(val);
      return toNumber
        .toLocaleString("th", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    percent: function(val) {
      if (val > 0) {
        return "+" + parseFloat(val).toFixed(2) + " %";
      }

      return parseFloat(val).toFixed(2) + " %";
    }
  },
  computed: {
    ...mapGetters("indice", ["getIndiceRanking"]),
    sortData() {
      return _shuffle(this.getIndiceRanking)
        .slice(0, 10)
        .filter(item => item.name !== this.exclude);
    }
  },
  created() {
    this.mixins_global_getIndiceFilter({ period: "1Y" });
  },
  methods: {
    onSelected({ name }) {
      this.$router.push({
        name: "miniapp-indices-quote",
        query: { name: name }
      });
      window.scroll(0, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
#section-other-indice {
  .trending-data {
    pointer-events: none;
    z-index: 0;
    label {
      z-index: -1;
    }
  }
}
.swiper-slide:last-of-type {
  margin-right: 60px !important;
  @include responsive(tablet) {
    margin-right: 80px !important;
  }
}
#search-loading {
  @extend %container-style;
  text-align: center;
  vertical-align: middle;
  .loading {
    text-align: center;
    font-size: 32px;
    margin: 50px auto auto;
    color: #bababa;
  }
}
</style>